import { useEffect } from 'react'

/**
 * Global scroll reveal: observes every .reveal element independently
 * and adds .in when it enters the viewport (once).
 * Matches the HTML prototype's IntersectionObserver behavior exactly.
 */
export function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in')
            observer.unobserve(e.target)
          }
        })
      },
      { threshold: 0.08, rootMargin: '0px 0px -50px 0px' }
    )

    // Use rAF to ensure all components have rendered
    requestAnimationFrame(() => {
      document.querySelectorAll('.reveal').forEach((el) => observer.observe(el))
    })

    return () => observer.disconnect()
  }, [])
}
